import React from 'react';
import { connect } from 'react-redux';
import { Footer } from 'app/components/Footer';
import { getSectionFromLocation } from 'app/routes';
import { routes } from 'app/routes/route-list';
import { isMultiLangEnabled, isBrokerEnabled, getMenu } from 'app/reducers/app-config';
import { BrokerFooter } from 'app/components/Broker/BrokerFooter';
import { Hidden } from '@material-ui/core';
import { getProduct, isOnLoanOfficerSite, PRODUCT } from 'app/util/headers';

const FooterContainer = ({ ...props }: any) => {
  const {
    activeSection,
    brokerEnabled,
    product,
    isBranchLandingRoute,
    isRootRoute,
    isOnLoanOfficerSite,
    menu,
  } = props;
  const isUsingFixedSubmitButton = activeSection && activeSection.fixedSubmitButton;

  const MobileWrapper = ({ children }: any) =>
    isBranchLandingRoute || isUsingFixedSubmitButton ? (
      <Hidden smDown>{children}</Hidden>
    ) : (
      children
    );

  return (
    (!isRootRoute || isOnLoanOfficerSite) && (
      <MobileWrapper>
        {brokerEnabled && product === PRODUCT.AUTO_PREQUAL ? <BrokerFooter {...props} /> : <Footer {...props} links={menu} />}
      </MobileWrapper>
    )
  );
};

const mapStateToProps = (state: any) => {
  return ({
    brokerEnabled        : isBrokerEnabled(state),
    product              : getProduct(),
    clientName           : state.config.clientDisplayName,
    clientType           : state.config.featureToggles?.clientType,
    menu                 : getMenu(state),
    activeSection        : getSectionFromLocation(state.router.location),
    isMultiLangEnabled   : isMultiLangEnabled(state),
    isRootRoute          : state.router.location.pathname === routes.root,
    isOnLoanOfficerSite  : isOnLoanOfficerSite(),
    isBranchLandingRoute :
      state.router.location.pathname === routes.branch ||
      state.router.location.pathname === routes.branchLendingOption,
  });
};

export default connect(mapStateToProps)(FooterContainer);
